import EyekandySyndicationLogging from "./classes/EyekandySyndicationLogging";
import EyekandyProjectsLogging from "./classes/EyekandyProjectsLogging";
import EyekandySyndicationCoverageLogging from "./classes/EyekandySyndicationCoverageLogging";

if(window){
    window.EyekandySyndicationLogging = EyekandySyndicationLogging
    window.EyekandyProjectsLogging = EyekandyProjectsLogging
    window.EyekandySyndicationCoverageLogging = EyekandySyndicationCoverageLogging
}

export const ESL = EyekandySyndicationLogging
export const EPL = EyekandyProjectsLogging
export const ESCL = EyekandySyndicationCoverageLogging
